import Header from "../home/header"
import icon from '../../assets/about/makhana.png'
import icon2 from '../../assets/about/makhana2.png'
import makhana from "../../assets/about/Healthy snack indulgence redefined.png"
import launch from "../../assets/about/launch.png"
import office from "../../assets/about/office.png"
import india from "../../assets/about/india.png"
import Footer from "../home/footer"
import lowcarbon from'../../assets/about/lowcarbon.png'
import packaging from'../../assets/about/Multi Layer Packaging.png'
import waste  from'../../assets/about/Waste.png'
import glutinfree from '../../assets/home/glutenfree.png'
import antioxidant from '../../assets/home/anti-Oxidant.png'
import nongmo from '../../assets/home/non-gmo.png'
import roastedinoliveoil from '../../assets/home/roasted-in-olive-oil.png'
import noaddedpreservatives from '../../assets/home/no-added-preservatives.png'
const about=()=>{
    return(
        <>
            <Header/>
            <div className="container-fluid"
                style={{
                    background:'#FBF8F3'
                }}
            >
                <div className="text-center">
                    <img src={makhana} alt="makhana" className="img-fluid"/>
                    <div style={{
                        position:'absolute',
                        zIndex:'99',
                        marginTop:'-200px'
                    }}>
                        <img src={icon} alt="makhana" className="iconmakhana img-fluid"/>
                    </div>

                    <div style={{
                        position:'absolute',
                        zIndex:'99',
                        marginTop:'-200px',
                        right:'0px'
                    }}>
                        <img src={icon2} alt="makhana" className="iconmakhana img-fluid"/>
                    </div>
                </div>

                <div className="slider-wrapper"
                    style={{
                    background:'#FFDA01'
                    }}
                >
                    <div className="slider-text text-uppercase" style={{color:'black'}}>
                    <span className="slide-item"><img src={nongmo}/> Non-GMO</span>
                    <span className="slide-item"><img src={noaddedpreservatives}/> NO Added Preservatives</span>
                    <span className="slide-item"><img src={roastedinoliveoil}/> Roasted in olive oil</span>
                    <span className="slide-item"><img src={antioxidant}/> anti-oxidants</span>
                    <span className="slide-item"><img src={glutinfree}/> glutine free</span>
                    
                    <span className="slide-item"><img src={nongmo}/> Non-GMO</span>
                    <span className="slide-item"><img src={noaddedpreservatives}/> NO Added Preservatives</span>
                    <span className="slide-item"><img src={roastedinoliveoil}/> Roasted in olive oil</span>
                    <span className="slide-item"><img src={antioxidant}/> anti-oxidants</span>
                    <span className="slide-item"><img src={glutinfree}/> glutine free</span>
                    

                    <span className="slide-item"><img src={nongmo}/> Non-GMO</span>
                    <span className="slide-item"><img src={noaddedpreservatives}/> NO Added Preservatives</span>
                    <span className="slide-item"><img src={roastedinoliveoil}/> Roasted in olive oil</span>
                    <span className="slide-item"><img src={antioxidant}/> anti-oxidants</span>
                    <span className="slide-item"><img src={glutinfree}/> glutine free</span>
                    
                    
                    </div>

                    <div className="slider-text text-uppercase">
                    <span className="slide-item"><img src={nongmo}/> Non-GMO</span>
                    <span className="slide-item"><img src={noaddedpreservatives}/> NO Added Preservatives</span>
                    <span className="slide-item"><img src={roastedinoliveoil}/> Roasted in olive oil</span>
                    <span className="slide-item"><img src={antioxidant}/> anti-oxidants</span>
                    <span className="slide-item"><img src={glutinfree}/> glutine free</span>
                    
                    <span className="slide-item"><img src={nongmo}/> Non-GMO</span>
                    <span className="slide-item"><img src={noaddedpreservatives}/> NO Added Preservatives</span>
                    <span className="slide-item"><img src={roastedinoliveoil}/> Roasted in olive oil</span>
                    <span className="slide-item"><img src={antioxidant}/> anti-oxidants</span>
                    <span className="slide-item"><img src={glutinfree}/> glutine free</span>
                    

                    <span className="slide-item"><img src={nongmo}/> Non-GMO</span>
                    <span className="slide-item"><img src={noaddedpreservatives}/> NO Added Preservatives</span>
                    <span className="slide-item"><img src={roastedinoliveoil}/> Roasted in olive oil</span>
                    <span className="slide-item"><img src={antioxidant}/> anti-oxidants</span>
                    <span className="slide-item"><img src={glutinfree}/> glutine free</span>
                    
                    </div>
                
                </div>

                <div className="timeline-section py-4" style={{ background: "#FBF8F3" }}>
                    <div className="container">
                        
                        {/* SECTION 1 */}
                        <div className="row align-items-center mb-5">
                        <div className="col-md-6 text-center">
                            <img src={launch} alt="makhana flavours" className="timeline-img" />
                        </div>

                        <div className="col-md-6 text-center text-md-start d-flex flex-column justify-content-center">
                            <h2 className="year">2020</h2>
                            <h3 className="title">Started with few flavours</h3>
                            <h4 className="desc">
                            Launch with magical flavour of Pudina Punch, Peri Peri,
                            Himalayan Salt, Cheese Herbs, and Tangy Tomato
                            </h4>
                        </div>
                        </div>

                        {/* SECTION 2 (Reverse) */}
                        <div className="row align-items-center mb-5 flex-md-row-reverse">
                        <div className="col-md-6 text-center">
                            <img src={office} alt="factory" className="timeline-img" />
                        </div>

                        <div className="col-md-6 text-center text-md-end d-flex flex-column justify-content-center">
                            <h2 className="year">2020</h2>
                            <h3 className="title">First Factory in Origin State Bihar</h3>
                            <h4 className="desc">
                            Launch our recycled jar, sustainable outside,
                            yummy makhana inside
                            </h4>
                        </div>
                        </div>

                        {/* SECTION 3 */}
                        <div className="row align-items-center">
                        <div className="col-md-6 text-center">
                            <img src={india} alt="pan india delivery" className="timeline-img" />
                        </div>

                        <div className="col-md-6 text-center text-md-start d-flex flex-column justify-content-center">
                            <h2 className="year">2020</h2>
                            <h3 className="title">Pan India Home Delivery</h3>
                            <h4 className="desc">
                            Launch our recycled jar, sustainable outside,
                            yummy makhana inside
                            </h4>
                        </div>
                        </div>

                    </div>
                </div>               
                                
            </div>
            <Footer/>
        </>
    )   
}
export default about